

























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CompanySideCard from "@/components/company/CompanySideCard.vue";
import { CompanyWithGeoAndDistanceBase } from "@/models/company.entity";
import { VSkeletonLoader } from "vuetify/lib";
import { CompanyServiceEnum } from "@/lib/enum/company-service.enum";

const CompanyMap = () => ({
  component: import(/* webpackPrefetch: true  */ /* webpackChunkName: "map" */ "@/components/company/CompanyMap.vue"),
  loading: VSkeletonLoader
});

@Component({
  components: {
    CompanySideCard,
    CompanyMap
  }
})
export default class CompanyMapDialog extends Vue {
  @Prop({ default: false }) value!: boolean;
  @Prop() coordinates!: any[];
  @Prop({ default: "" }) title!: string;
  @Prop({ default: CompanyServiceEnum.WORKSHOP }) filter!: string;
  @Prop({ default: "" }) search!: string;

  dialog: boolean = this.value;

  @Watch("value")
  onValueChange(val: boolean) {
    this.dialog = val;
  }

  @Watch("dialog")
  onDialogChange(val: boolean) {
    this.$emit("input", val);
  }

  @Watch("dialog")
  onDialogOpened(val: boolean) {
    if (val) {
      this.$nextTick(() => {
        const mapRef = this.$refs.map as Vue & { forceResize: () => void };
        mapRef?.forceResize?.();
      });
    }
  }

  selectCompany(company: CompanyWithGeoAndDistanceBase) {
    this.$emit("select", company);
    this.dialog = false;
  }

  get isMobile() {
    return this.$vuetify.breakpoint.mobile;
  }
}
